import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23ba5d2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-center pa-6"
}
const _hoisted_3 = {
  key: 1,
  class: "text-body-2 text-medium-emphasis my-4 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "text-body-2 text-medium-emphasis text-center my-4"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex-grow-1 min-w-0" }
const _hoisted_7 = { class: "text-body-2 font-weight-bold nombre-torneo" }
const _hoisted_8 = { class: "text-caption text-medium-emphasis" }
const _hoisted_9 = {
  key: 1,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_10 = { class: "px-3 pb-3" }
const _hoisted_11 = { class: "d-flex flex-wrap ga-2" }
const _hoisted_12 = {
  key: 2,
  class: "text-center mt-2"
}
const _hoisted_13 = { class: "nombre-torneo flex-grow-1 min-w-0 text-subtitle-1 text-sm-h6 pt-1" }

import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useDisplay } from "vuetify";
import { ViewPartidaTorneoDTO } from "@/interfaces/Partidas";
import {
  ejercitoDelJugador,
  idJugadorDelLado,
  juegaEnLado1,
} from "@/utils/partidaParejas";
import { ClasificacionTorneosDTO } from "@/interfaces/Usuario";
import CardPartidaTorneo from "../PartidasTorneo/CardPartidaTorneo.vue";
import { nombreEvento } from "@/Constant/FormatoTorneo";
import { compararPartidasTorneo, textoPosicion } from "@/utils/historialJugador";

interface ResumenTorneo {
  clave: string;
  nombreTorneo: string;
  // Torneo, Liga o Copa
  formato: string;
  posicion: number | null;
  // Cuántos hay en la clasificación final
  totalJugadores: number | null;
  partidas: ViewPartidaTorneoDTO[];
  jugadas: number;
  victorias: number;
  empates: number;
  derrotas: number;
  puntosFavor: number;
  puntosContra: number;
  ejercito: string;
  ultimaFecha: number;
}

// eslint-disable-next-line no-undef
const TANDA = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'TablaTorneosDisputados',
  props: {
    clasificacionTorneos: {},
    tournamentMatches: {},
    idUsuario: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const search = ref<string | null>("");
const expanded = ref<string[]>([]);
const showPartidas = ref<boolean>(false);
const torneoSeleccionado = ref<ResumenTorneo | null>(null);
const { xs } = useDisplay();
const route = useRoute();

const cuantosVer = ref(TANDA);
const filtroFormato = ref<string>("todos");
const fecha = (ms: number) => new Date(ms).toLocaleDateString("es-ES");
const plural = (nombre: string) => (nombre === "Torneo" ? "Torneos" : `${nombre}s`);
const normalizar = (texto: string) =>
  texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const toggleExpand = (clave: string) => {
  expanded.value = expanded.value.includes(clave)
    ? expanded.value.filter(c => c !== clave)
    : [...expanded.value, clave];
};

const abrirPartidas = (torneo: ResumenTorneo) => {
  torneoSeleccionado.value = torneo;
  showPartidas.value = true;
};

// Al pulsar un nick en una partida se navega a otro jugador: cerrar el modal y empezar de cero
watch(
  () => route.params.idUsuario,
  () => {
    showPartidas.value = false;
    expanded.value = [];
    filtroFormato.value = "todos";
    search.value = "";
    cuantosVer.value = TANDA;
  }
);
watch([filtroFormato, search], () => {
  cuantosVer.value = TANDA;
});

// Agrupa por idTorneo; si el back aún no lo envía, por nombre
const claveTorneo = (idTorneo?: number, nombreTorneo?: string) =>
  idTorneo ? `id-${idTorneo}` : `nombre-${nombreTorneo ?? ""}`;

const nuevoResumen = (clave: string, nombreTorneo: string): ResumenTorneo => ({
  clave,
  nombreTorneo,
  formato: "Torneo",
  posicion: null,
  totalJugadores: null,
  partidas: [],
  jugadas: 0,
  victorias: 0,
  empates: 0,
  derrotas: 0,
  puntosFavor: 0,
  puntosContra: 0,
  ejercito: "-",
  ultimaFecha: 0,
});

const ejercitoMasJugado = (ejercitos: string[]): string => {
  const conteo = new Map<string, number>();
  ejercitos.forEach(e => conteo.set(e, (conteo.get(e) ?? 0) + 1));
  let masJugado = "-";
  let maximo = 0;
  conteo.forEach((veces, ejercito) => {
    if (veces > maximo) {
      masJugado = ejercito;
      maximo = veces;
    }
  });
  return masJugado;
};

const resumenTorneos = computed<ResumenTorneo[]>(() => {
  const resumen = new Map<string, ResumenTorneo>();
  const ejercitos = new Map<string, string[]>();

  const obtenerFila = (clave: string, nombreTorneo: string): ResumenTorneo => {
    let fila = resumen.get(clave);
    if (!fila) {
      fila = nuevoResumen(clave, nombreTorneo);
      resumen.set(clave, fila);
    }
    return fila;
  };

  (props.tournamentMatches ?? []).forEach(partida => {
    // Partidas sin resultado todavía (ronda en juego) no cuentan
    if (partida.resultadoUsuario1 == null || partida.resultadoUsuario2 == null)
      return;

    const clave = claveTorneo(partida.idTorneo, partida.nombreTorneo);
    const fila = obtenerFila(clave, partida.nombreTorneo ?? "-");

    const esJugador1 = juegaEnLado1(partida, props.idUsuario);
    const propios = esJugador1
      ? partida.resultadoUsuario1
      : partida.resultadoUsuario2;
    const rival = esJugador1
      ? partida.resultadoUsuario2
      : partida.resultadoUsuario1;

    fila.partidas.push(partida);
    fila.formato = nombreEvento(partida.formatoTorneo);
    fila.jugadas++;
    fila.puntosFavor += propios;
    fila.puntosContra += rival;
    if (partida.ganadorPartidaTorneo === idJugadorDelLado(partida, props.idUsuario))
      fila.victorias++;
    else if (!partida.ganadorPartidaTorneo) fila.empates++;
    else fila.derrotas++;

    const fecha = partida.fechaPartida
      ? new Date(partida.fechaPartida).getTime()
      : 0;
    fila.ultimaFecha = Math.max(fila.ultimaFecha, fecha);

    const ejercito = ejercitoDelJugador(partida, props.idUsuario);
    if (ejercito && ejercito !== "N/A") {
      ejercitos.set(clave, [...(ejercitos.get(clave) ?? []), ejercito]);
    }
  });

  ejercitos.forEach((lista, clave) => {
    obtenerFila(clave, "-").ejercito = ejercitoMasJugado(lista);
  });

  // En el modal, las partidas en orden de juego
  resumen.forEach(fila => fila.partidas.sort(compararPartidasTorneo));

  // La posición viene de la clasificación guardada al cerrar el torneo
  (props.clasificacionTorneos ?? []).forEach(clasificacion => {
    const clave = claveTorneo(clasificacion.idTorneo, clasificacion.nombreTorneo);
    const fila = obtenerFila(clave, clasificacion.nombreTorneo);
    fila.posicion = clasificacion.resultado;
    fila.totalJugadores = clasificacion.totalJugadores ?? null;
  });

  return [...resumen.values()].sort((a, b) => b.ultimaFecha - a.ultimaFecha);
});

// Torneo, Liga o Copa: el filtro solo sale si ha jugado más de uno
const formatos = computed(() => [...new Set(resumenTorneos.value.map(t => t.formato))]);
const filtrados = computed(() => {
  const texto = normalizar(search.value ?? "").trim();
  return resumenTorneos.value.filter(
    t =>
      (filtroFormato.value === "todos" || t.formato === filtroFormato.value) &&
      (!texto || normalizar(t.nombreTorneo).includes(texto))
  );
});
const visibles = computed(() => filtrados.value.slice(0, cuantosVer.value));

const colorPosicion = (posicion: number) => {
  if (posicion === 1) return "amber-darken-2";
  if (posicion === 2) return "blue-grey-lighten-1";
  if (posicion === 3) return "brown-lighten-1";
  return "primary";
};

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            })
          ]))
        : (resumenTorneos.value.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Aún no ha jugado ningún evento. "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (formatos.value.length > 1)
                ? (_openBlock(), _createBlock(_component_v_chip_group, {
                    key: 0,
                    modelValue: filtroFormato.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtroFormato).value = $event)),
                    mandatory: "",
                    column: "",
                    "selected-class": "text-primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_chip, {
                        value: "todos",
                        size: "small",
                        filter: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Todos (" + _toDisplayString(resumenTorneos.value.length) + ")", 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formatos.value, (f) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          key: f,
                          value: f,
                          size: "small",
                          filter: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(plural(f)) + " (" + _toDisplayString(resumenTorneos.value.filter(t => t.formato === f).length) + ") ", 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_text_field, {
                modelValue: search.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                label: "Buscar evento",
                "prepend-inner-icon": "mdi-magnify",
                density: "compact",
                clearable: "",
                "hide-details": "",
                class: "mt-1 mb-3"
              }, null, 8, ["modelValue"]),
              (filtrados.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, " No hay eventos con estos filtros. "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (item) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  key: item.clave,
                  variant: "outlined",
                  class: "mb-2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "pa-3 d-flex align-center ga-2 clickable-row",
                      onClick: ($event: any) => (toggleExpand(item.clave))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.nombreTorneo), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createTextVNode(_toDisplayString(item.formato), 1),
                          (item.ultimaFecha)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString(fecha(item.ultimaFecha)), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (item.jugadas)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" · " + _toDisplayString(item.victorias) + "-" + _toDisplayString(item.empates) + "-" + _toDisplayString(item.derrotas), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (item.posicion !== null)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            color: colorPosicion(item.posicion),
                            variant: "flat",
                            size: "small",
                            class: "flex-shrink-0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(textoPosicion)(item.posicion, item.totalJugadores)), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, "Sin posición")),
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(expanded.value.includes(item.clave) ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_5),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            (item.jugadas)
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 0,
                                  color: "primary",
                                  variant: "flat",
                                  size: "small",
                                  "prepend-icon": "mdi-sword-cross",
                                  "append-icon": "mdi-chevron-right",
                                  onClick: _withModifiers(($event: any) => (abrirPartidas(item)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.jugadas) + " " + _toDisplayString(item.jugadas === 1 ? "partida" : "partidas"), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_chip, {
                              variant: "flat",
                              color: "green-darken-2",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.victorias) + " V ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_chip, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.empates) + " E", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_chip, {
                              variant: "flat",
                              color: "red-darken-2",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.derrotas) + " D ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_chip, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.puntosFavor) + " pts a favor", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_chip, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.puntosContra) + " pts en contra", 1)
                              ]),
                              _: 2
                            }, 1024),
                            (item.ejercito !== '-')
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 1,
                                  size: "small",
                                  "prepend-icon": "mdi-shield"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.ejercito), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ], 512), [
                          [_vShow, expanded.value.includes(item.clave)]
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (filtrados.value.length > visibles.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      size: "small",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (cuantosVer.value += TANDA))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Ver más (" + _toDisplayString(filtrados.value.length - visibles.value.length) + ") ", 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showPartidas.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showPartidas).value = $event)),
      fullscreen: _unref(xs),
      "max-width": "600",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-start ga-2 text-wrap" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(torneoSeleccionado.value?.nombreTorneo), 1),
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  density: "comfortable",
                  class: "flex-shrink-0",
                  "aria-label": "Cerrar",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showPartidas.value = false))
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "px-2 px-sm-4" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(torneoSeleccionado.value?.partidas, (partida) => {
                  return (_openBlock(), _createBlock(CardPartidaTorneo, {
                    key: partida.idPartidaTorneo,
                    match: partida,
                    idUsuario: _ctx.idUsuario,
                    mostrarTorneo: false,
                    class: "mb-3"
                  }, null, 8, ["match", "idUsuario"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, { class: "pa-3" }, {
              default: _withCtx(() => [
                (!_unref(xs))
                  ? (_openBlock(), _createBlock(_component_v_spacer, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  block: _unref(xs),
                  variant: "tonal",
                  color: "secondary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showPartidas.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cerrar ")
                  ]),
                  _: 1
                }, 8, ["block"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "fullscreen"])
  ], 64))
}
}

})